import { apiSelector } from '@ackee/redux-utils';

import type { AppState } from '@/types';

import { MODULE_PREFIX } from '../../constants';

export const selectExportApi = (state: AppState) => apiSelector(state, MODULE_PREFIX, 'export');
export const selectImportApi = (state: AppState) => apiSelector(state, MODULE_PREFIX, 'import');
